import { useCallback } from 'react';
import { translateEnumValue } from '../utils/translateEnumValue';
import { usePageTranslation } from './useZlfTranslation';

const ROLE_TRANSLATION_GROUP = 'roles';

/** 角色代碼（org_admin…）對應的畫面名稱，與側邊欄、使用者選單共用 Layout 語系檔 */
export function useRoleDisplayName(): (roleCode: string) => string {
    const { t } = usePageTranslation({ filePath: 'shared/components/Layout' });
    return useCallback(
        (roleCode: string) => translateEnumValue(t, ROLE_TRANSLATION_GROUP, roleCode),
        [t]
    );
}
